import type { CountryCode, CurrencyCode, Locale } from '@fluxora/types';

export interface CountryConfig {
  code: CountryCode;
  name: string;
  locale: Locale;
  currency: CurrencyCode;
  timezone: string;
  dateFormat: string;
  themeVariant: 'default' | 'bg' | 'gb' | 'ie' | 'nl' | 'se' | 'us';
}

export const COUNTRY_CONFIGS: Record<CountryCode, CountryConfig> = {
  BG: {
    code: 'BG',
    name: 'Bulgaria',
    locale: 'bg-BG',
    currency: 'BGN',
    timezone: 'Europe/Sofia',
    dateFormat: 'dd.MM.yyyy',
    themeVariant: 'bg',
  },
  GB: {
    code: 'GB',
    name: 'United Kingdom',
    locale: 'en-GB',
    currency: 'GBP',
    timezone: 'Europe/London',
    dateFormat: 'dd/MM/yyyy',
    themeVariant: 'gb',
  },
  IE: {
    code: 'IE',
    name: 'Ireland',
    locale: 'en-IE',
    currency: 'EUR',
    timezone: 'Europe/Dublin',
    dateFormat: 'dd/MM/yyyy',
    themeVariant: 'ie',
  },
  NL: {
    code: 'NL',
    name: 'Netherlands',
    locale: 'nl-NL',
    currency: 'EUR',
    timezone: 'Europe/Amsterdam',
    dateFormat: 'dd-MM-yyyy',
    themeVariant: 'nl',
  },
  SE: {
    code: 'SE',
    name: 'Sweden',
    locale: 'sv-SE',
    currency: 'SEK',
    timezone: 'Europe/Stockholm',
    dateFormat: 'yyyy-MM-dd',
    themeVariant: 'se',
  },
  US: {
    code: 'US',
    name: 'United States',
    locale: 'en-US',
    currency: 'USD',
    timezone: 'America/New_York',
    dateFormat: 'MM/dd/yyyy',
    themeVariant: 'us',
  },
};

export function getCountryConfig(code: CountryCode): CountryConfig {
  return COUNTRY_CONFIGS[code];
}
